import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';

@Component({
  selector: 'app-pos-invoice-pay-with-deposit-dialog',
  templateUrl: './pos-invoice-pay-with-deposit-dialog.component.html',
  styleUrls: ['./pos-invoice-pay-with-deposit-dialog.component.css']
})
export class PosInvoicePayWithDepositDialogComponent implements OnInit {
  busy:boolean = false;
  form: FormGroup;

  invoice = {
    invoiceNumber: '',
    invoiceBalance: 0,
    salesOrderNumber: '',
    depositBalance: 0
  };

  constructor(
    private dialogRef: MatDialogRef<PosInvoicePayWithDepositDialogComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private dialog: MatDialog
  ) {
    this.form = fb.group({
      invoiceNumber: [null, Validators.compose([Validators.required])],
      amount: [null, Validators.compose([Validators.required, Validators.min(1)])],

    });
  }

  ngOnInit() {
    this.baseService.executeCommand<any>('portal_pos_payment_invoice_from_deposit_dialog_config', this.data)
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.invoice = response.data;

          const invoiceBalance = +response.data.invoiceBalance;
          const depositBalance = +response.data.depositBalance;
          const amount = invoiceBalance <= depositBalance ? invoiceBalance : depositBalance;

          this.form.controls['invoiceNumber'].setValue(response.data.invoiceNumber);
          this.form.controls['invoiceNumber'].updateValueAndValidity();

          this.form.controls['amount'].setValue(+amount.toFixed(2));
          this.form.controls['amount'].setValidators(Validators.compose([Validators.required, Validators.min(0.01),Validators.max(+amount.toFixed(2))]));
          this.form.controls['amount'].updateValueAndValidity();


        } else {
          this.dialogRef.close(false);
        }
      });
  }

  save() {
    const dialogData: OiGroupDialogData = {
      title: 'Paying Invoice from Deposit',
      function: 'portal_oi_group_payment_invoice_from_deposit',
      postBody: this.form.getRawValue()
    };

    const ref = this.dialog.open(OiGroupProcessDialogComponent, {
      data: dialogData,
      width: '450px'
    });

    ref.afterClosed().subscribe(oiResult => {
      if (oiResult.responseCode === 0 && oiResult.data && oiResult.data.groupProcessedSuccessfully === true) {
        this.dialogRef.close(true);
      }
    });
  }

}
